import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

import { Storage } from '@ionic/storage-angular';
import { CryptoService } from './crypto.service';

export enum EnumStorageKeys {
    Language = "scc_bo.language",
    Session = "scc_bo.session",
    Preferences = "scc_bo.preferences",
    Edtion = 'scc_bo.edition',
    Remember = 'scc_bo.remember',
    Version = 'scc_bo.version'
}

@Injectable(
    {
        providedIn: 'root'
    })
export class StorageService {
    private storage: Storage | null = null;

    private Encrypt: boolean = false;

    private project: string = "";

    constructor(private Storage: Storage, private cryptoService: CryptoService) {}

    /**
     * Inicializa storage.
     */
    async Init(idProject: string = "") {

        this.project = idProject || 'm';

        this.storage = await this.Storage.create();

        this.Encrypt = environment?.EncryptStorage || false;

        this.cryptoService.Init("++" + idProject);
    }

    /**
     * Guarda em local storage um conjunto de dados para uma determinada key.
     * Caso guarde com sucesso os dados devolve os proprios dados, caso contrário devolve null.
     * @param key valor enum EnumStorageKeys
     * @param data any valor a ser guardado
     * @returns 
     */
    async Save(key: EnumStorageKeys, data: any) {
        try {

            const key2 = key.replace('_bo', `_bo_${this.project}`),
                encoded = this.Encrypt ? await this.cryptoService.encryptData(JSON.stringify(data)) : JSON.stringify(data);

            // console.log(encoded);

            await this.storage?.set(key2, encoded);

            return data;
        }
        catch (error) {
            return null;
        }
    }

    /**
     * 
     * @param key 
     * @returns 
     */
    async Delete(key: EnumStorageKeys) {
        try {

            const key2 = key.replace('_bo', `_bo_${this.project}`);

            await this.storage?.remove(key2);

            return null;
        }
        catch (error) {
            return null;
        }
    }

    /**
     * 
     */
    async DeleteAll(keepVersion: boolean = true) {
        try {

            Object.entries(EnumStorageKeys).forEach(async ([key, value]) => {
                // console.log(value);

                if ((keepVersion && !key.includes('Version')) || !keepVersion)
                    await this.Delete(value);
            })

            return null;
        }
        catch (error) {
            return null;
        }
    }

    /**
     * Efectua leitura em local storage de uma determinada key e devolve o seu valor.
     * Caso a key não existe ou seja possivel efectuar o parse de dados devolve null.
     * @param key valor enum EnumStorageKeys
     * @returns 
     */
    async Get(key: EnumStorageKeys) {
        try {
            const key2 = key.replace('_bo', `_bo_${this.project}`),
                value = await this.storage?.get(key2);

            // return JSON.parse(value);
            return this.Encrypt ? JSON.parse(await this.cryptoService.decryptData(value)) : JSON.parse(value);
        }
        catch (error) {
            return null;
        }
    }
}
